import InfiniteLoader from "react-window-infinite-loader";

import useTypedContext from "hooks/useTypedContext";
import useErrorHandle from "hooks/useErrorHandle";
import ListEntitiesNew from "components/ListEntitiesNew";
import EmptyState from "ds/components/EmptyState";
import { EmptystateHelmetColored } from "components/icons/generated";
import { SpacesContext } from "views/Account/SpacesProvider";

import PoliciesListFiltersLayout from "../../PolicyDetails/Samples/FiltersLayout";
import PolicyDetailsSamplesListVirtualizedItem from "../../PolicyDetails/Samples/VirtualizedItem";
import useSearchPolicySampleSuggestions from "../../PolicyDetails/Samples/useSearchPolicySampleSuggestions";
import useSearchPolicySample from "../../PolicyDetails/Samples/useSearchPolicySample";
import { ENTITIES_PER_PAGE } from "../../PolicyDetails/Samples/constants";

type LoginPolicyDetailsSamplesProps = {
  id: string;
};

const LoginPolicyDetailsSamples = ({ id }: LoginPolicyDetailsSamplesProps) => {
  const { hasEntityCreateAccess: canManagePolicies } = useTypedContext(SpacesContext);

  const {
    entities,
    error,
    isPageEmpty,
    hasNoFilteringResults,
    loading,
    isItemLoaded,
    loadMoreItems,
  } = useSearchPolicySample(id);

  const {
    filters,
    filtersMap,
    sortOptions,
    loading: filtersLoading,
    refetchActiveSections,
    filteredCount,
  } = useSearchPolicySampleSuggestions(id);

  const ErrorContent = useErrorHandle(error);

  if (ErrorContent) {
    return ErrorContent;
  }

  return (
    <PoliciesListFiltersLayout
      isPageEmpty={isPageEmpty}
      renderedEntitiesCount={entities.length}
      loadingIndication={loading}
      filters={filters}
      filtersMap={filtersMap}
      sortOptions={sortOptions}
      filtersLoading={filtersLoading}
      refetchActiveSections={refetchActiveSections}
      filteredCount={filteredCount}
    >
      {isPageEmpty && (
        <EmptyState
          title="You don't have any evaluation records yet"
          icon={EmptystateHelmetColored}
          caption={`Create policy samples by setting sample to "true" inside policy body.`}
        ></EmptyState>
      )}
      {hasNoFilteringResults && (
        <EmptyState
          title="No results"
          icon={EmptystateHelmetColored}
          caption="Try different filters."
        />
      )}
      {!!entities.length && (
        <InfiniteLoader
          isItemLoaded={isItemLoaded}
          itemCount={entities.length + ENTITIES_PER_PAGE}
          loadMoreItems={loadMoreItems}
        >
          {({ onItemsRendered }) => (
            <ListEntitiesNew
              itemCount={entities.length}
              itemProps={{
                items: entities,
                canManagePolicies,
                policyId: id,
              }}
              virtualizedItem={PolicyDetailsSamplesListVirtualizedItem}
              itemKey={(index) => entities[index].key}
              onItemsRendered={onItemsRendered}
            />
          )}
        </InfiniteLoader>
      )}
    </PoliciesListFiltersLayout>
  );
};

export default LoginPolicyDetailsSamples;
